import styled from 'styled-components'

export const MobileFlyoutContent = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
`
